import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import SurveyPage from "@/pages/SurveyPage";

export const Route = createFileRoute("/survey/$token")({
  head: () => pageHead("Service Feedback", "Rate the service on your contract.", "/survey/$token", true),
  component: SurveyPage,
});
